<script setup lang="ts">
  import type { FillLogsBefore } from '../model/fill-logs-text';
  import FillLogsValueText from './FillLogsValueText.vue';

  defineProps<{ before: FillLogsBefore }>();
</script>

<template>
  <span
    class="mt-0.5 block text-xs/4 text-gray-03"
    data-testid="fill-logs-before"
  >
    <span class="font-medium">Antes:</span>
    {{ ' ' }}<FillLogsValueText :value="before" />{{ ' ' }}<span>{{ before.origin }}</span>
  </span>
</template>
